import React, { useEffect, useRef, useState } from "react"
import { GatsbyImage } from "gatsby-plugin-image"

export default function CareersHero({
  header,
  subHeader,
  links,
  backgroundImage,
}) {
  const splitHeader = header.split(" ")
  const description = subHeader.subHeader.split("\n\n")
  const [headerStyle, setHeaderStyle] = useState({})
  const headerRef = useRef(null)

  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current) {
        const footer = document.querySelector("footer") // Adjust selector if needed
        const footerTop = footer ? footer.getBoundingClientRect().top : Infinity
        const headerHeight = headerRef.current.getBoundingClientRect().height

        const bottomSpace = window.innerHeight - footerTop + 48

        if (headerHeight + bottomSpace + 96 <= window.innerHeight) {
          setHeaderStyle({})
        } else {
          setHeaderStyle({
            bottom: `${Math.abs(bottomSpace)}px`,
          })
        }
      }
    }

    window.addEventListener("scroll", handleScroll)
    window.addEventListener("resize", handleScroll)
    handleScroll() // Initial check

    return () => {
      window.removeEventListener("scroll", handleScroll)
      window.removeEventListener("resize", handleScroll)
    }
  }, [])

  return (
    <section className="w-full mx-auto text-secondary">
      <div
        style={headerStyle}
        className="md:fixed md:grid md:grid-cols-5 gap-8 -z-0"
      >
        <div ref={headerRef} className="md:max-w-xs lg:max-w-sm col-span-2">
          <h1 className="text-7xl lg:text-9xl xl:text-[8rem] uppercase mb-12 font-bold flex flex-col text-secondary">
            {splitHeader.map((word, index) => (
              <span key={`header-${index}`}>{word} </span>
            ))}
          </h1>
          <div className="space-y-4 font-sans leading-6">
            {description.map((item, index) => {
              const isBold = item.startsWith("__") && item.endsWith("__")
              return (
                <p key={index} className={isBold ? "font-bold" : ""}>
                  {item.replace(/__/g, "")}
                </p>
              )
            })}
          </div>
        </div>
      </div>
      <div className="grid grid-rows-6">
        {backgroundImage && (
          <div className="relative row-span-4">
            <GatsbyImage
              className="absolute top-0 w-full h-full aspect-2"
              image={backgroundImage.gatsbyImageData}
              alt={backgroundImage.title}
            />
          </div>
        )}
      </div>
    </section>
  )
}
